import React from "react"
import { GetTable } from "../../common/components/DataTable"
import { CaldaiaDto } from "../../generated"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import { CaldaieStore } from "../caldaieStore";
import { Loading } from "../../common/components/loading";
import { DeleteButton } from "../../common/components/DeleteButton";
import CaldaieActions from "../caldaieActions";

const Table = GetTable<CaldaiaDto>();
export default () => {
    const data = CaldaieStore.useAll();
    if (!data)
        return <Loading />
    return <div className="card">
        <div className="card-header d-flex bg-theme align-items-center" >
            <h3 className="text-white flex-fill">Modelli caldaie</h3>
            <Link to={links.caldaieImport} className="btn btn-outline-secondary me-1"><i className="fas fa-download" /> Importa modelli</Link>
            <Link to={links.caldaieNew} className="btn btn-outline-secondary"><i className="fas fa-plus" /> Aggiungi</Link>
        </div>
        <div className="card-body">
            <Table
                data={data}
                keySelector={x => x.idCaldaia.toString()}
                filterables={[x => x.marcaCaldaia, x => x.modelloCaldaia]}
            >
                <Table.Column
                    template={x => <Link to={links.caldaieEdit(x.idCaldaia)}>{x.marcaCaldaia}</Link>}
                    header="Marca"
                    orderBy={x => x.marcaCaldaia ?? ""}
                    groupBy={x => x.marcaCaldaia ?? ""}
                />
                <Table.Column
                    header="Modello"
                    template={x => x.modelloCaldaia}
                />
                <Table.Column
                    header="Focolare"
                    template={x => x.potenzaFocolare < 0 ? "N.C" : `${x.potenzaFocolare} KW`}
                    orderBy={x => x.potenzaFocolare ?? 0}
                />
                <Table.Column
                    header="Nominale"
                    template={x => x.potenzaUtile < 0 ? "N.C" : `${x.potenzaUtile} KW`}
                    orderBy={x => x.potenzaUtile ?? 0}
                />
                <Table.Column
                    template={x => <DeleteButton onDelete={() => CaldaieActions.delete(x.idCaldaia)} />}
                    orderable={false}
                    groupable={false}
                />
            </Table>
        </div>
    </div>
}
